import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function personalInformationSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page4Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page4Overlay.value = true;
  const requestModel = {
    dropOffStep: "S5",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      personInformation: {
        title: ccFormValue.value.personalInformation.title,
        genderCode: ccFormValue.value.personalInformation.gender,
        raceCode: ccFormValue.value.personalInformation.race,
        otherRace: ccFormValue.value.personalInformation.otherRace,
        residencyStatusCode:
          ccFormValue.value.basicInformation.nationality == "MY"
            ? ccFormValue.value.personalInformation.residencyStatus
            : "U",
        maritalStatusCode: ccFormValue.value.personalInformation.maritalStatus,
        motherMaidenName:
          ccFormValue.value.personalInformation.motherMaidenName,
        numberOfDependents: ccFormValue.value.personalInformation.dependency,
        academicQualification: ccFormValue.value.personalInformation.academic,
        otherQualification: ccFormValue.value.personalInformation.otherAcademic,
        residentialAddress: {
          addressLine1:
            ccFormValue.value.personalInformation.residentialAddress1,
          addressLine2:
            ccFormValue.value.personalInformation.residentialAddress2,
          addressLine3:
            ccFormValue.value.personalInformation.residentialAddress3,
          postcode: ccFormValue.value.personalInformation.postCode,
          city: ccFormValue.value.personalInformation.city,
          state: ccFormValue.value.personalInformation.state,
          durationOfStay: {
            year: ccFormValue.value.personalInformation.yearStay,
            month: ccFormValue.value.personalInformation.monthStay,
          },
        },
        residentialOwnership:
          ccFormValue.value.personalInformation.residentialOwnership,
        permanentAddress: {
          addressLine1: ccFormValue.value.personalInformation.permanentAddress1,
          addressLine2: ccFormValue.value.personalInformation.permanentAddress2,
          addressLine3: ccFormValue.value.personalInformation.permanentAddress3,
          postcode: ccFormValue.value.personalInformation.postCode2,
          city: ccFormValue.value.personalInformation.city2,
          state: ccFormValue.value.personalInformation.state2,
        },
      },
    },
  };
  MasterService.pageSubmit(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        ccFormValue.value.dropOffStep = 5;
        if (ccFormValue.value.summarySetting.personalInformationJump == true) {
          ccFormValue.value.summarySetting.personalInformationJump = false;
          jumpStep(12, "", "4");
          page4Overlay.value = false;
        } else {
          if (prop.type == "PF_CC") jumpStep(7, "", "4");
          else jumpStep(5, "", "4");
          page4Overlay.value = false;
        }
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page4Overlay.value = false;
    });
}
